import EmptyLayout from '@/layouts/EmptyLayout.vue';
import { ISnotrRoute } from '..';

export default [
  {
    path: '/paychecks/new',
    name: 'PaychecksNew',
    meta: {
      title: 'TabTitle.newPaycheck',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paychecks-new.vue'),
    props: route => ({
      workRelationId: route.query.workRelationId,
      subUnitId: route.query.subUnitId,
      periodId: route.query.periodId,
      advancedPaycheckMode: false,
    }),
  },
  {
    path: '/paychecks/:id',
    name: 'PaychecksEdit',
    meta: {
      title: 'TabTitle.editPaycheck',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paychecks-edit.vue'),
    props: route => ({
      paycheckId: route.params.id,
      advancedPaycheckMode: false,
    }),
  },
  {
    path: '/paychecks/:id/pdf',
    name: 'PaychecksPdf',
    meta: {
      title: 'TabTitle.pdfPaycheck',
      layout: EmptyLayout,
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paychecks-pdf.vue'),
  },
  {
    path: '/paychecks',
    name: 'Paychecks',
    meta: {
      title: 'TabTitle.paychecks',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/paychecks.vue'),
    props: () => ({
      advancedPaycheckMode: false,
    }),
  },
] as ISnotrRoute[];
